import React, { Fragment } from 'react'
import { compose } from 'redux'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import cx from 'classnames'
import { Alert, AlertTitle } from '@material-ui/lab'
import Button from '@material-ui/core/Button'

// import pictureIcon from '../../../assets/icons/navbar/picture.svg'
import shareIcon from '../../../assets/icons/navbar/share.svg'
import homeIcon from '../../../assets/icons/navbar/home.svg'
// import translateIcon from '../../../assets/icons/navbar/translate.svg'
import bookmarkIcon from '../../../assets/icons/navbar/bookmark.svg'
import environment from '../../../config'

import * as directoryActions from '../../../actions/components/directory'
import * as intlActions from '../../../actions/components/intl'
import DialogComponent from '../../../containers/hoc/Dialog'
import BackgroundLayer from './BackgroundLayer'
// import URLParser from 'helpers/urlParser'

class Navbar extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showSwitchLangDialog: false,
      iphoneBookmarkAlert: false,
      androidBookmarkAlert: false,
    }
  }

  toggleSwitchLangDialog = () => this.setState({ showSwitchLangDialog: !this.state.showSwitchLangDialog })
  toggleShareDialog = () => this.props.updateDisplayShareDialog(!this.props.directory.display.shareDialog)
  openCoverImageDialog = () => this.props.updateDisplayCoverImage(true)

  switchLang = (lang, index) => {
    const { merchant, switchLocale, setUserLocale } = this.props

    this.setState(
      { showSwitchLangDialog: false },
      async () => {
        await switchLocale(merchant.clientLocales[index])
        await setUserLocale(merchant.clientLocales[index])
        window.location.reload()
      })
  }

  bookmark = () => {
    if ((/iphone|ipod|ipad/i).test(window.navigator.userAgent)) {
      this.setState({ iphoneBookmarkAlert: !this.state.iphoneBookmarkAlert })
    } else if (/android/i.test(window.navigator.userAgent)) {
      this.setState({ androidBookmarkAlert: !this.state.androidBookmarkAlert })
    } else {
      console.log(window.navigator.userAgent)
    }
  }

  handleA2hs = () => {
    const promptEvent = window.deferredPrompt
    if (!promptEvent) {
      console.log('stopped')
      return
    }
    promptEvent.prompt()
    promptEvent.userChoice.then((result) => {
      window.deferredPrompt = null
    })
  }
  /* handleA2hs = () => {
    let deferredPrompt
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      deferredPrompt = e
      console.log(e)
    })

    document.getElementById('pwa').addEventListener('click', (e) => {
      document.getElementById('pwa').style.display = 'none'
      if (deferredPrompt) {
        deferredPrompt.prompt()
        deferredPrompt.userChoice
          .then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              console.log('User accepted the A2HS prompt')
            } else {
              console.log('User dismissed the A2HS prompt')
            }
            deferredPrompt = null
          })
      }
    })
    this.setState({ androidBookmarkAlert: !this.state.androidBookmarkAlert })
  } */

  renderSwitchLangDialogComponent = () => {
    const { intl, merchant } = this.props
    const _list = []

    if (
      merchant == null ||
      merchant.clientLocales === undefined ||
      merchant.clientLocales == null
    ) {
      // do nothing before getting clientLocales from server
      return
    } else {
      merchant.clientLocales.forEach(element => {
        _list.push(intl.formatMessage({ id: 'lang.' + element, value: element }))
      })
    }

    if (this.state.showSwitchLangDialog) {
      return (
        <DialogComponent
          triggerModal={this.switchLang}
          dialogType='operation'
          list={_list}
          onClose={() => {
            this.toggleSwitchLangDialog()
            this.toggleMenu()
          }}
        />
      )
    }
  }

  render () {
    const {
      intl,
      classes,
      merchant,
      directory,
    } = this.props

    if (!merchant) return null

    const { shareDialog } = directory.display
    /* const {
      facebookLink,
      instagramLink,
      whatsappLink,
      lineLink,
      wechatLink,
    } = merchant.setting */
    // const displayShareIcon = Boolean(facebookLink + instagramLink + whatsappLink + lineLink + wechatLink)
    const isFromLanding = window.sessionStorage.getItem('ref') === 'landing'
    const androidAlert = intl.formatMessage({ id: 'bookmark.androidAlert' })
    const androidDownload = intl.formatMessage({ id: 'bookmark.androidDownload' })
    const iphoneAlertTitle = intl.formatMessage({ id: 'bookmark.iphoneAlertTitle' })
    const iphoneAlert1 = intl.formatMessage({ id: 'bookmark.iphoneAlert1' })
    const iphoneAlert2 = intl.formatMessage({ id: 'bookmark.iphoneAlert2' })
    const displayBookmark = (/android/i.test(window.navigator.userAgent) || (/iphone|ipod|ipad/i).test(window.navigator.userAgent)) && !window.matchMedia('(display-mode: standalone)').matches
    return (
      <Fragment>
        <div className={classes.navbar}>
          <div className={classes.navbarLeft}>
            {
              isFromLanding &&
              <div className={classes.icon} onClick={() => {
                window.location.href = environment.landingUrl
              }}>
                <img src={homeIcon} alt="home" />
              </div>
            }
            {/* <div className={classes.icon} onClick={this.openCoverImageDialog}>
              <img src={pictureIcon} alt='picture_icon' />
            </div> */}
          </div>
          <div className={classes.navbarRight}>
            {
              /* displayShareIcon &&  (
                <div className={cx(classes.icon, { [classes.activeIcon]: shareDialog })} onClick={this.toggleShareDialog} >
                  <img src={shareIcon} alt='shareIcon' />
                </div>
              ) */
            }
            {/* <div className={classes.icon} onClick={ this.toggleSwitchLangDialog }>
              <img src={translateIcon} alt='translate_icon' />
            </div> */}
          </div>
          <div className={classes.navbarRight}>
            {
              displayBookmark && (
                <div className={classes.icon} onClick={this.bookmark}>
                  <img src={bookmarkIcon} alt='bookmark_icon' />
                </div>
              )
            }
          </div>
        </div>
        <div className={classes.navbarTitle}>
          <div className={classes.navabrCenter}>
            <BackgroundLayer>
              <p className={classes.title}>{merchant.name}</p>
            </BackgroundLayer>
          </div>
        </div>
        {
          this.state.iphoneBookmarkAlert === true &&
          <div>
            <Alert severity="info" onClose={this.bookmark}>
              <AlertTitle>{iphoneAlertTitle}</AlertTitle>
              {iphoneAlert1} <img src='https://img.icons8.com/fluent-systems-filled/24/000000/upload.png' /> {iphoneAlert2}
            </Alert>
          </div>
        }
        {
          this.state.androidBookmarkAlert === true &&
          <div>
            <Alert
              severity="info"
              action={
                <Button color="inherit" size="small" onClick={() => { this.handleA2hs() }} /* id="pwa" */>
                  {androidDownload}
                </Button>
              }
            >
              {androidAlert}
            </Alert>
          </div>
        }
        {this.renderSwitchLangDialogComponent()}
      </Fragment>
    )
  }
}

const styles = {
  navbar: {
    height: 50,
    boxSizing: 'border-box',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '15fr 2fr 2fr',
    color: '#ffffff',
    padding: '6px 8px 0px 40px',
  },
  navbarTitle: {
    height: 30,
    boxSizing: 'border-box',
    width: '100%',
    display: 'grid',
    color: '#ffffff',
    padding: '0px',
  },
  navbarLeft: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'flex-start',
  },
  navbarRight: {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'flex-end',
    transition: 'all 2000ms ease',
  },
  navabrCenter: {
    flex: 1,
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '0px 8px',
  },
  title: {
    margin: 0,
    fontSize: 20,
  },
  icon: {
    boxSizing: 'border-box',
    width: 32,
    height: 32,
    padding: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  activeIcon: {
    backgroundColor: 'gray',
    borderRadius: 800,
  },
  buttonText: {
    flex: 1,
    color: '#ffffff',
  },
}

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
    directory: state.directory,
  }
}

const mapDispatchToProps = {
  updateDisplayShareDialog: directoryActions.updateDisplayShareDialog,
  updateDisplayCoverImage: directoryActions.updateDisplayCoverImage,
  switchLocale: intlActions.switchLocale,
  setUserLocale: intlActions.setUserLocale,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet(styles),
  injectIntl,
)(Navbar)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/Navbar.jsx